import React from "react"

import { AttachmentType } from "shared/types/__generated__/graphql"

import { AttachmentLinkForm } from "features/attachment-links/ui/AttachmentLinkForm"

import { useRoomFormAttachmentsContext } from "../context/RoomFormAttachmentsContext"
import { useRoomFormContext } from "../contexts/RoomFormContext"

function getFormFieldName(attachment: AttachmentType) {
  return `attachments.${attachment.id}`
}

export const RoomFormAttachmentsTab = React.memo(() => {
  const { attachments, linkedAttachments, attachmentCategories, onUpload } =
    useRoomFormAttachmentsContext()

  const { isReadonly } = useRoomFormContext()

  return (
    <div className="room-form__tab-content room-form__tab-content--attachments">
      <AttachmentLinkForm
        attachments={attachments}
        linkedAttachments={linkedAttachments}
        getName={getFormFieldName}
        categories={attachmentCategories}
        isReadonly={isReadonly}
        onUpload={onUpload}
      />
    </div>
  )
})
